import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("同步模板")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_page_wrapper, null, {
    default: _withCtx(() => [
      _createVNode(_component_we_table, { onRegister: _ctx.register }, {
        headerButton: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.sync_lark_contract
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        teams: _withCtx(({ record }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.teams, (item) => {
            return (_openBlock(), _createBlock(_component_a_button, {
              type: "link",
              key: item.team__name
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.team__name), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        action: _withCtx(({ record }) => [
          _createVNode(_component_a_button, {
            type: "link",
            onClick: ($event: any) => (_ctx.editTemplate(record))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["onRegister"])
    ]),
    _: 1
  }, 512)), [
    [_directive_loading, _ctx.loading]
  ])
}